import templateUrl from './workers-compensation-dashboard.component.html'
import { UtilityService } from '../../../../core/services/utility.service'
import moment from 'moment';
import { IWindowService } from 'angular';

export const WorkersCompensationDashboardComponent = {
    templateUrl,
    controller: workersCompensationDashboard,
    controllerAs: "vm"
};

function workersCompensationDashboard(apexApiUrl: string, utilityService: UtilityService,
    $window: IWindowService) {
    'ngInject';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this; // eslint-disable-line no-invalid-this

    vm.$onInit = $onInit;

    vm.startDate;
    vm.endDate;
    vm.downloadReport = downloadReport;

    function $onInit() {

    }

    function downloadReport() {
        const args: any = {};

        if (!vm.startDate || !vm.endDate) {
            return;
        }
        if (vm.startDate) {
            args.StartDate = moment(vm.startDate).format("YYYY-MM-DD");
        }
        if (vm.endDate) {
            args.EndDate = moment(vm.endDate).format("YYYY-MM-DD");
        }

        const queryString = Object.keys(args).reduce(function (query, key) {
            return (query ? query + "&" : "?") + key + "=" + args[key];
        }, "");

        $window.location.href = $window.encodeURI(apexApiUrl + "reports/workers-compensation.xlsx" + queryString);
    }
}
